export default class Accordion {
  constructor() {
    const accordionToggle = document.querySelectorAll('.js-accordionToggle');

    accordionToggle.forEach((elm) => {
      elm.addEventListener('click', this.toggle);
    });
  }

  toggle(event) {
    event.preventDefault();
    const self = event.currentTarget;
    const targetId = self.getAttribute('aria-controls');
    const target = document.getElementById(targetId);

    if (target.getAttribute('aria-hidden') === 'true') {
      // slide down
      self.setAttribute('aria-expanded', 'true');
      target.setAttribute('aria-hidden', 'false');
      let height = target.firstElementChild.clientHeight;
      target.style.height = 0;
      target.style.height = height + "px";

    } else {
      // slide up
      self.setAttribute('aria-expanded', 'false');
      target.setAttribute('aria-hidden', 'true');

      target.style.height = target.firstElementChild.clientHeight + "px";
      target.style.height = 0;
    }
    return false;
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new Accordion();
});
